import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./MejoraRegulatoria.css";
import { mejoraRegulatoria } from "../../../json/mejoraregulatoria";

const PaaasSsh = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container informacion-container">
      <div className="row">
        <div className="col-12">
          <div className="informacion_title">
            <h1>Programa Anual de Mejora Regulatoria</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {mejoraRegulatoria.map((item, index) => (
          <div className="col-md-4 col-sm-6 col-12" >      
              <h1 className="links-informacion">
                  <Link target="_blank" to={item.item_url}>
                    {item.item_nombre}
                  </Link> 
                  <h6> {item.item_descripcion}</h6>
              </h1>
             
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaaasSsh;
